import { gql } from "config/graphql";
import { IPaymentMethod } from "config/types";
import { gqlQuery } from "store/apollo";

interface IActivePaymentMethodResponse {
  data: {
    activePaymentMethod: IPaymentMethod;
  };
}

export const activePaymentMethodQuery = (): Promise<IActivePaymentMethodResponse> => {
  const query = gql`
    query activePaymentMethod {
      activePaymentMethod {
        id
        source
        status
        name
        metadata
        externalId
        mask
        financialConnectionsAccount {
          id
          status
        }
        createdAt
        updatedAt
      }
    }
  `;

  return gqlQuery<IActivePaymentMethodResponse["data"]>({ query });
};
